import { render, staticRenderFns } from "./editBunkersTable.vue?vue&type=template&id=0463c61b"
import script from "./editBunkersTable.vue?vue&type=script&lang=js"
export * from "./editBunkersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports